import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Volunteers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/volunteers").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="fade-in" data-testid="volunteers-page">
      <div className="eyebrow text-njas-sage-hover text-[10px]">CRM</div>
      <h2 className="font-serif text-3xl text-njas-navy mb-6">Volunteers</h2>
      <div className="rounded-xl bg-white border border-[var(--njas-border)] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-njas-bg-alt text-njas-muted text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-5 py-3">Name</th>
                <th className="text-left px-5 py-3">Email</th>
                <th className="text-left px-5 py-3">Location</th>
                <th className="text-left px-5 py-3">Availability</th>
                <th className="text-left px-5 py-3">Lived exp.</th>
                <th className="text-left px-5 py-3">Received</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="px-5 py-10 text-center text-njas-muted">Loading…</td></tr>}
              {!loading && rows.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-njas-muted">No volunteer applications yet.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-[var(--njas-border)] hover:bg-njas-bg-alt/60" data-testid={`volunteer-row-${r.id}`}>
                  <td className="px-5 py-3">{r.full_name}</td>
                  <td className="px-5 py-3 text-njas-muted">{r.email}</td>
                  <td className="px-5 py-3 text-njas-muted">{r.location || "—"}</td>
                  <td className="px-5 py-3 text-njas-muted">{r.availability || "—"}</td>
                  <td className="px-5 py-3 text-njas-muted">{r.lived_experience ? "Yes" : "No"}</td>
                  <td className="px-5 py-3 text-njas-muted">{new Date(r.created_at).toLocaleDateString("en-AU")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
